import { Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Modal from '../../../../common/modal'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import FileInput from '../../../../common/fileInput'
import { useEffect, useState } from 'react'
import * as XLSX from 'xlsx';
import { focusElemnt, navigation3 } from '../../../../common/helper'
import { getParyMasterRateUpload } from '../../../../../store/generalSetting/GSAction'
import { useDispatch } from 'react-redux'
import { updateAlertError } from '../../../../../store/common/common_action'
import UpdatePartyRatesModal from './UpdatePartyRatesModal'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { billingUnitList } from '../constants'


const AddNewPartyRatesModal = (props) => {
  const dispatch = useDispatch()
  const { dataValues: { loginData, filters, cityList }, updateModal,  } = props
  const theme = useTheme()
  const [fileData, setFileData] = useState(null)
  const [tableData, setTableData] = useState([])
  const [apiData, setApiData] = useState([])
  const [showTable, setShowTable] = useState(false)
  const [showUpdatePartyRateModal, setShowUpdatePartyRateModal] = useState(false)
  const [updatePartyRateData, setUpdatePartyRateData] = useState({})
  const [isSuccess, setIsSuccess] = useState(false)

  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  useEffect(() => {
    focusElemnt('rateSampleBtn')
  }, [])
  const width = window.innerWidth - 40
  useEffect(() => {
    const readExcelOrCSV = () => {
      if (!fileData) {
        console.log('No file selected.')
        return
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });

        // Assuming there is only one sheet in the Excel file
        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        // Convert the sheet data to JSON
        const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        // Display the content on the console
        const nonEmptyRows = data.filter(row => row.some(cell => cell !== undefined && cell !== null && cell !== ''));
        // let newData = nonEmptyRows?.map((val, i)=>([...val,val[6]:billingUnitList[val[6]]]))
        let newData = nonEmptyRows?.map((val, i) => {
          // Create a copy of the array
          let newRow = [...val];
          
          // Modify the specific index with the new value
          newRow[6]= billingUnitList.find(unit => unit.name === val[6])?.id;
          // Return the modified array
          return newRow;
        });
        let newData1 = nonEmptyRows?.map((val) => {
          // Create a copy of the array
          let newRow = [...val];
  
          // Find city names for fromCityId (index 4) and toCityId (index 5) using filter
          const fromCity = cityList.filter(city => city.CityID === val[4]);
          const toCity = cityList.filter(city => city.CityID === val[5]);
  
          // Check if the filter result is not empty and access the first element safely
          const fromCityName = fromCity.length > 0 ? fromCity?.[0]?.CityName : '';
          const toCityName = toCity.length > 0 ? toCity?.[0]?.CityName : '';
  
          // Append the city name along with the ID in parentheses
          newRow[4] = `${val[4]} (${fromCityName})`;
          newRow[5] = `${val[5]} (${toCityName})`;
  
          // Return the modified array
          return newRow;
        });
        // Display the content on the console
        setApiData(newData?.slice(1))
        setTableData(newData1?.slice(1))
      };

      reader.readAsArrayBuffer(fileData);

    };

    // Call the function when fileData changes
    readExcelOrCSV();
  }, [fileData]);
  const tableHeader = [
    { headerName: 'Company ID', field: "companyId", headerSx: { minWidth: "12.44%", textAlign: 'left' }, showfilter: false },
    { headerName: 'Party ID', field: "partyId", headerSx: { minWidth: "11.11%", textAlign: 'left' }, showfilter: true },
    { headerName: 'Service Type ID', field: "serviceTypeId", headerSx: { minWidth: "11.11%", textAlign: 'left' }, showfilter: true },
    { headerName: 'Cons. Type ID', field: "consTypeId", headerSx: { minWidth: "12.33%", textAlign: 'left' }, showfilter: true },
    { headerName: 'From City ID', field: "fromCityId", headerSx: { minWidth: "12.33%", textAlign: 'left' }, showfilter: true },
    { headerName: 'To City ID', field: "toCityId", headerSx: { minWidth: "12.33%", textAlign: 'left' }, showfilter: true },
    { headerName: 'Billing Unit', field: "billingUnit", headerSx: { minWidth: "12.33%", textAlign: 'left' }, showfilter: true },
    { headerName: 'Rate', field: "rate", headerSx: { minWidth: "12.33%", textAlign: 'right' }, showfilter: true },
  ]

  const renderTableRows = () => {
    return tableData.map((val, index) => (
      <TableRow key={`DR-${index}`}>
        {val.map((cell, cellIndex) => (
          <TableCell key={`DRC-${index}-${cellIndex}`} sx={{ minHeight: '36px', textAlign: cellIndex === 7 ? 'right' : 'left', fontSize: '12px', color: '#444' }}>
            {cell}
          </TableCell>
        ))}
      </TableRow>
    ));
  }

  const handleSave = () => {
    if (fileData === null) {
      dispatch(updateAlertError({ show: true, msg: 'Please Select A File For Uploading', success: false, nextId: `chooseFileInput` }))
    } else if (!showTable) {
      dispatch(updateAlertError({ show: true, msg: 'Please Upload The File', success: false, nextId: `uploadBtn` }))
    } else {
      getUpdatePartyRatesModalInfo()
    }
   
  }
  const handleSuccessModalClose = () => {
    updateModal()
    setIsSuccess(false) 
}
  const saveApi = () => {
    let obj = {
      CompanyID: loginData?.intCompanyID,
      PartyIDs: apiData.map(array => array[1])?.join('^'),
      FromCityIDs: apiData.map(array => array[4])?.join('^'),
      ToCityIDs: apiData.map(array => array[5])?.join('^'),
      ServiceTypeIDs: apiData.map(array => array[2])?.join('^'),
      ConsignmentIDs: apiData.map(array => array[3])?.join('^'),
      BillingUnits: apiData.map(array => array[6])?.join('^'),
      Rates: apiData.map(array => array[7])?.join('^'),
      UserID: loginData?.intUserID,
      IsActive: 1
    }
    dispatch(getParyMasterRateUpload(obj))?.then((res) => {
      if (res?.status == 'Success') {
        setIsSuccess(true)
        setShowUpdatePartyRateModal(false)
      } else {
        updateAlertError({ show: true, msg: res.Message, success: false, nextId: `focApprConsType` })
      }
    }).catch((err) => {
      console.log("Error:", err)
    })
  }
  const getUpdatePartyRatesModalInfo = () => {
    let data = {
      filters: filters,
      saveApi: saveApi,
      setIsSuccess:setIsSuccess,
      isSuccess:isSuccess
    }
    setShowUpdatePartyRateModal(true)
    setUpdatePartyRateData(data)
  }
const handleUpload = () => {
  if (!fileData) {
    dispatch(updateAlertError({ show: true, msg: 'Please Select A File For Uploading', success: false, nextId: `focApprConsType` }))
    return
  }else{
    setShowTable(true)
  }
}
  return (<>
    <Modal
      headTxt={'Upload File'}
      width={'68%'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Grid container sx={{ display: 'flex', gap: '16px', padding: '15px 15px 10px 15px', flexWrap: 'nowrap' }}>
        <Item sx={{ ...sx.itemsx, width: '22%' }} className="">
          <Button
            variant="contained"
            id={'rateSampleBtn'}
            color="secondary"
            sx={{ width: '100%', fontSize: '16px' }}
            className="receiveitembtn"
            startIcon={<CloudDownloadIcon />}
            onClick={() => {
              window.open('/sample.xlsx', '_blank')
            }}
            onKeyDown={(e) => navigation3(e, 'chooseFileInput', 'saveBtn', () => { })}
          >
            Rate  sample
          </Button>
        </Item>
        <Item sx={{ ...sx.itemsx, width: '61%' }} onClick={() => { setShowTable(false) }} className="disabled-wrapper">
          <FileInput id={'chooseFileInput'} width={`${Math.ceil((width * 40) / 100)}px`} label={'Choose file'} fileChange={setFileData} accept={".xls, .xlsx"} value={''}
            onKeyDown={(e) => navigation3(e, 'uploadBtn', 'rateSampleBtn', () => { })}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '17%' }} className="">
          <Button
            variant="outlined"
            color="secondary"
            id={'uploadBtn'}
            sx={{ width: '100%' }}
            className="receiveitembtn"
            startIcon={<CloudUploadIcon style={{ color: theme.palette.secondary.main }} />}
            onClick={() => {
              handleUpload()
              // setShowTable(true)
            }}
            onKeyDown={(e) => navigation3(e, 'saveBtn', 'chooseFileInput', () => { })}
          >
            UPLOAD
          </Button>
        </Item>
      </Grid>
      <Grid container sx={{ paddingX: '15px', marginBottom: '10px', height: '45vh' }}>
        {showTable && <TableContainer component={Paper} className="scrollBlue" sx={{ marginY: '5px', maxHeight:'300px' }}>
          <Table
            stickyHeader
            size="small"
            aria-label="a dense table"
            sx={{
              '& .MuiTableCell-root': {
                padding: '6px 4px !important',
              },
            }}
          >
            <TableHead>
              <TableRow>
                {tableHeader.map((row, index) => {
                  return (
                    <TableCell
                      sx={{
                        ...row.headerSx,
                        backgroundColor: '#DAEDFE',
                        minHeight: '36px',
                        fontSize: '12px',
                        fontWeight: '600',
                        color: '#444',
                      }}
                    >
                      {row.headerName}
                    </TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {renderTableRows()}
            </TableBody>
          </Table>
        </TableContainer>}
      </Grid>
      <Grid container sx={{ display: 'flex', gap: '16px', padding: '15px', justifyContent: 'flex-end', borderTop: '1px solid rgba(221, 221, 221, 1)' }}>
        <Item sx={{ ...sx.itemsx }} className="" >
          <Button
            id="saveBtn"
            style={{ margin: '0px 0px 0px 5px', height: "40px" }}
            className="btn add-btn"
            variant="contained"
            color="error"
            onClick={() => { handleSave() }}
            onKeyDown={(e) => {
              navigation3(e, 'rateSampleBtn', 'uploadBtn', () => { });
            }}
          >
            Save
          </Button></Item>
      </Grid>
    </Modal>
    {showUpdatePartyRateModal && <UpdatePartyRatesModal dataValues={updatePartyRateData} updateModal={setShowUpdatePartyRateModal} />}
    <SuccessAndErrorModal handleClose={() => {handleSuccessModalClose()}} open={isSuccess} title={'Updated Party Rates \n Saved Successfully!'} modalStyle={modalStyle} />
  </>
  )
}

export default AddNewPartyRatesModal
